import { deleteObject, getStorage, ref } from "firebase/storage";

export const deleteImage = async (url: string) => {
    const encoded = decodeURIComponent(url);
    const replaced = encoded.replace("https://firebasestorage.googleapis.com/v0/b/active-waiting.appspot.com/o/", "");
    const fileName = replaced.substring(0, replaced.indexOf("?"));

    const storage = getStorage();
    const storageRef = ref(storage, fileName);

    if (!storageRef) return;

    await deleteObject(storageRef);
};
